<template>
    <div>
        <span v-if="remainingTime >= 0 && readyToShow()"> 
            <small class="text-muted">
                <strong>No show</strong>: 
                <strong :class="[remainingTime <= 900000 ? 'text-danger' : '']">{{ formatRemainingTime(remainingTime) }}</strong>
                <md-icon icon="timelapse"></md-icon>
            </small>
        </span>
        <span v-else-if="serviceStatus == 'active' && readyToShow()">
            <small class="text-muted">
                <strong>No show </strong>
                <md-icon icon="timer_off"></md-icon>
            </small>
        </span>
    </div>
</template>

<script>

export default {
    props: {
		pickupDatetime: {
			type : String,
			required: true
		},
        tripType: {
            type: String,
            required: true
        },
        serviceStatus: {
            type: String,
            required: true
        },
        trackingStatus: {
            type: String,
            required: true
        }
	},
    
    data() {
        const arrivalBufferMs   = 3600000
        const departureBufferMs = 900000
        return {
            remainingTime : null,
            arrivalBufferMs: arrivalBufferMs,
            departureBufferMs: departureBufferMs,
            extraTime: null,
            interval: null
        }
    },
    methods: {
        calculateRemainingTime() {
            const now          = new Date().getTime();
            this.extraTime     = this.tripType == 'A2H' ? this.arrivalBufferMs : this.departureBufferMs
            const scheduleTime = new Date(this.pickupDatetime).getTime() + this.extraTime;
            this.remainingTime = scheduleTime - now;
        },
        formatRemainingTime(ms) {
            const minutes = Math.floor((ms / (1000 * 60)) % 60);
            const seconds = Math.floor((ms / 1000) % 60);
            return `${minutes >= 1 ? minutes + 'm': ''} ${minutes <= 0 ? seconds + "s" : ''}`;
        },
        formatRemainingTime2(ms) {
            const seconds = Math.floor((ms / 1000) % 60);
            const minutes = Math.floor((ms / (1000 * 60)) % 60);
            const hours   = Math.floor((ms / (1000 * 60 * 60)) % 24);
            const days    = Math.floor(ms / (1000 * 60 * 60 * 24));
            return `${days > 0 ? days + " días, " : ""}${hours}h ${minutes}m ${seconds}s`;
        },
        readyToShow() {
            const now          = new Date();
            const scheduleTime = new Date(this.pickupDatetime);
            return now >= scheduleTime
        }
    },
    mounted() {
        this.calculateRemainingTime()
        clearInterval(this.interval);
        this.interval = setInterval(this.calculateRemainingTime, 1000);
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
}
</script>